import type { TFunction } from 'i18next';

const errorTypeToTranslationKey: Record<string, string> = {
  OAuthExchangeCodeFailed: 'descopeErrors.oauthSignInFailed',
  UserDoesNotExists: 'descopeErrors.userNotInvited',
};

const oauthSignInFailedErrorPattern = /E062108|E062209/i;
const userNotInvitedErrorPattern = /SavvyUserNotInvited/i;

export const createDescopeErrorMessageTransformer =
  (t: TFunction) =>
  (error: { text: string; type: string }): string => {
    if (error.type === 'UserDoesNotExists') {
      return t('descopeErrors.userNotInvited');
    }

    if (userNotInvitedErrorPattern.test(error.text)) {
      return t('descopeErrors.userNotInvited');
    }

    if (oauthSignInFailedErrorPattern.test(error.text)) {
      return t('descopeErrors.oauthSignInFailed');
    }

    const translationKey = errorTypeToTranslationKey[error.type];

    if (translationKey) {
      return t(translationKey);
    }

    return error.text;
  };
